/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { token } from '@atlaskit/tokens';

import { GRID_SIZE } from 'src/constants/gridsize';

export const DropMenuContainer = styled.div<{
  showValueDescription: boolean;
  allowEmptyChoice: boolean;
  fitContainer: boolean;
  shiftLeft?: boolean;
  shiftRight?: boolean;
}>`
  margin-left: ${({ shiftLeft }) => (shiftLeft ? token('space.200') : '0px')};
  margin-right: ${({ shiftRight }) =>
    shiftRight ? token('space.200') : '0px'};

  & [data-testid='privilegesDropdown--trigger'] {
    text-align: left;
    align-items: center;
    min-width: ${({ showValueDescription, allowEmptyChoice }) => {
      let multiplier = 13;
      if (allowEmptyChoice) {
        multiplier = 18;
      } else if (showValueDescription) {
        multiplier = 45;
      }
      return GRID_SIZE * multiplier;
    }}px;
    max-width: ${({ fitContainer }) => (fitContainer ? '100%' : '360px')};
    height: auto;
    min-height: ${({ showValueDescription }) =>
      showValueDescription ? 64 : 0}px;
    &[disabled],
    :hover,
    :focus {
      align-items: center;
      text-align: left;
      height: auto;
    }
  }
`;

export const PermissionDescription = styled.p({
  whiteSpace: 'break-spaces',
});

export const PermissionsTriggerDescriptionContainer = styled.div({
  "& [role='menuitem']": {
    backgroundColor: 'transparent',
    textAlign: 'left',
    color: 'inherit',
    ':hover, :focus': {
      backgroundColor: 'transparent',
      color: 'inherit',
    },
  },
});
